export default __webpack_public_path__ + "static/international-metric-desktop-2a50d8021066d5da234f609b2eab76f5.svg";